import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
// Basic Components
import Button from 'screens/components/basic/Button';
import EmailInput from 'screens/components/basic/EmailInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
class POSSMSReceiptDialog extends Component {
    render() {
        const { t } = this.props; 
        return (
            <div>
                {(this.props.show) ?
                    <DialogInput
                        title={<DialogHeader text={t('pos.smsReceiptDialog.fillPhoneNum')} classicClass="posDialogClassic" />}
                        modal={true}
                        open={this.props.show}
                        autoScrollBodyContent={true}
                        style={{ zIndex: '950' }}
                        actions={[
                            <Button
                                key={1}
                                type="CancelButton"
                                name="buttonCancel"
                                className="btn-space"
                                label={t('pos.smsReceiptDialog.dropLater')}
                                onTouchTap={() => this.props.onCancel()} />,
                            <Button
                                key={2}
                                name="buttonConfirmCashIn"
                                className="btnNewBrandPOS"
                                label={t('common.confirm')}
                                primary={true}
                                onTouchTap={() => this.props.onComfirm()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h4 className="purpleText">
                                    {t('pos.smsReceiptDialog.fillPhoneNum')}
                                    </h4>
                                </div>
                                <div className="col-lg-12">
                                    <MaskedTextInput
                                        fullWidth={true}
                                        name={this.props.name + "SMS"}
                                        label={t('pos.smsReceiptDialog.phoneNumber')}
                                        floatingLabelText={t('pos.smsReceiptDialog.phoneNumber')}
                                        hintText={t('pos.smsReceiptDialog.phoneNumber')}
                                        mask="(999)999-9999"
                                    />
                                </div>
                            </div>
                        </div>
                    </DialogInput>
                    : ""}
            </div>
        )
    }
}

function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSSMSReceiptDialog))